import React from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewUrlUnified } from "./PreviewUrlUnified";
import { PreviewLayout } from "@/components/previews";

/**
 * Wrapper de compatibilidad para PreviewUrlStatic
 * Mantiene la API existente mientras usa la lógica unificada
 */
export default function PreviewUrlStatic(props: QRProps<"url-static">) {
  return (
    <PreviewLayout
      page="url-static"
      dataQA="preview-url-static-container"
      includeBrowser
    >
      <PreviewUrlUnified
        qrProps={props}
        page="url-static"
        translationKey="url_static"
      />
    </PreviewLayout>
  );
}
